import React from 'react'
import Link from 'next/link'
import Logo from '@assets/svgs/logo'

export const HEADER_ARGS = {
  links: [
    {
      text: 'Locations',
      href: '/locations',
      id: 'locations',
    },
    {
      text: 'Help Center',
      href: '/help',
      id: 'help',
    },
  ],
  dropdownLinks: [
    {
      text: 'Locations',
      href: '/locations',
      mobileOnly: true,
      id: 'locations',
    },
    {
      text: 'Help Center',
      href: '/help',
      mobileOnly: true,
      id: 'help-center',
    },
    {
      text: 'Check Status',
      href: '/status',
      id: 'status',
    },
    {
      text: 'Look Up KTN',
      href: '/ktn-lookup',
      id: 'ktn-lookup',
    },
  ],
  logo: (
    <Link href="/">
      <a aria-label="home page" data-cy="top-navigation-home">
        <Logo />
      </a>
    </Link>
  ),
}

export type HeaderArgs = typeof HEADER_ARGS

export const getLookupFlowUpdatedMenu = (
  updatedLookupFlow?: boolean
): HeaderArgs => {
  if (updatedLookupFlow === undefined) {
    return {
      links: [],
      dropdownLinks: [],
      logo: (
        <Link href="/">
          <a aria-label="home page" data-cy="top-navigation-home">
            <Logo />
          </a>
        </Link>
      ),
    }
  }

  if (updatedLookupFlow) {
    return {
      links: [
        {
          text: 'Check Status',
          href: '/status',
          id: 'status',
        },
        {
          text: 'Look Up KTN',
          href: '/ktn-lookup',
          id: 'ktn-lookup',
        },
        {
          text: 'Locations',
          href: '/locations',
          id: 'locations',
        },
        {
          text: 'Help Center',
          href: '/help',
          id: 'help',
        },
      ],
      dropdownLinks: [
        {
          text: 'Locations',
          href: '/locations',
          mobileOnly: true,
          id: 'locations',
        },
        {
          text: 'Help Center',
          href: '/help',
          mobileOnly: true,
          id: 'help-center',
        },
        {
          text: 'Check Status',
          href: '/status',
          mobileOnly: true,
          id: 'status',
        },
        {
          text: 'Look Up KTN',
          href: '/ktn-lookup',
          mobileOnly: true,
          id: 'ktn-lookup',
        },
      ],
      logo: (
        <Link href="/">
          <a aria-label="home page" data-cy="top-navigation-home">
            <Logo />
          </a>
        </Link>
      ),
    }
  }

  return HEADER_ARGS
}
